export const ERROR_CODE_OFFER_TM_NOT_ENOUGH_PLACES = 1320;
